export default __webpack_public_path__ + "static/media/dollar.80c10190.svg";